"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Substep = void 0;
const react_1 = __importStar(require("react"));
const Substep_styles_1 = require("./Substep.styles");
const WrapperSubstep_1 = require("../WrapperSubstep/WrapperSubstep");
const helpers_1 = require("../../../helpers");
const icons_1 = require("../../../icons");
const StackView_1 = require("../../../StackView");
const Text_1 = require("../../../Text");
exports.Substep = (0, helpers_1.createUIElement)('Substep', (_a, ref) => {
    var { className, title, description, isCompleted = false, isDisabled = false, label, onClick, style, ['data-selector-id']: initialDataSelectorId } = _a, rest = __rest(_a, ["className", "title", "description", "isCompleted", "isDisabled", "label", "onClick", "style", 'data-selector-id']);
    const dataSelectorId = (0, react_1.useMemo)(() => initialDataSelectorId || 'getting-started-substep', [initialDataSelectorId]);
    return (react_1.default.createElement(WrapperSubstep_1.WrapperSubstep, Object.assign({}, rest, { ref: ref, style: style, isCompleted: isCompleted, "data-selector-id": dataSelectorId, className: (0, helpers_1.cn)('vm-Substep', className) }),
        react_1.default.createElement(Substep_styles_1.StyledSubstepNumber, { direction: StackView_1.STACK_DIRECTION.column, align: StackView_1.STACK_ALIGN.center },
            react_1.default.createElement(Substep_styles_1.StyledNumber, null, isCompleted && react_1.default.createElement(Substep_styles_1.StyledSubstepCheckIcon, { src: react_1.default.createElement(icons_1.CheckIcon, null) })),
            react_1.default.createElement(Substep_styles_1.StyledSubstepLine, null)),
        react_1.default.createElement(Substep_styles_1.StyledSubstepBody, { "data-selector-id": `${dataSelectorId}-body`, direction: StackView_1.STACK_DIRECTION.column, gap: StackView_1.STACK_GAP.xs, isDisable: isDisabled, onClick: (e) => {
                if (!isDisabled) {
                    onClick === null || onClick === void 0 ? void 0 : onClick(e);
                }
            }, tabIndex: -1, isInteractable: onClick !== null },
            react_1.default.createElement(StackView_1.StackView, { gap: StackView_1.STACK_GAP.s },
                react_1.default.createElement(Text_1.Text, { size: Text_1.TEXT_SIZE.m, weight: Text_1.TEXT_WEIGHT.bold, view: isDisabled ? Text_1.TEXT_VIEW.light : Text_1.TEXT_VIEW.primary }, title),
                label && !isDisabled && react_1.default.createElement(Substep_styles_1.StyledSubstepLabel, { type: label })),
            description && (react_1.default.createElement(Text_1.Text, { size: Text_1.TEXT_SIZE.m, view: isDisabled ? Text_1.TEXT_VIEW.light : Text_1.TEXT_VIEW.primary }, description)))));
});
//# sourceMappingURL=Substep.js.map